(() => {
  const filtersForm = document.querySelector('.m18__filters');
	if (!filtersForm) {
		return;
	}

	// If filter used, scroll to form.
	if (window.location.href.indexOf('filter-location') > -1) {
		document.getElementById('vacancies').scrollIntoView();
	}

	// Submit form when dropdowns are changed.
	const filters = document.querySelectorAll('.m18__filter');
	filters.forEach(filter => {
		filter.addEventListener('change', () => {
			filtersForm.submit();
		});
	});

	// Reset form.
	const reset = document.querySelector('.m18__reset');
	reset.addEventListener('click', () => {
		filtersForm.reset();
		filtersForm.submit();
	});
})();
